module.exports = __webpack_public_path__ + "static/media/sponsor2@2x.f62ae2c7.png";